import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/datamart2-general-types/datamart2/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchDatamart2Tenants =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useSuspenseQuery
